<template>
    <!--弹窗-->
    <el-dialog
        :visible="true"
        width="80%"
        title="绑定广告组合名称"
        :before-close="handleClose"
    >
        <el-form ref="formData" label-width="120px" size="mini">
            <el-form-item label="搜索：" class="query-form-item">
                <el-input style="width: 200px;" clearable v-model="searchTxt" placeholder="输入要搜索的内容" size="mini"></el-input>
            </el-form-item>

            <el-row class="selectBox">
                <el-col :span="12">
                    <el-form-item label="未选项" class="query-form-item"></el-form-item>
                    <el-form-item label="" class="query-form-item">
                        <el-checkbox
                            v-for="item in getNoSelList"
                            :key="item.portfolio_id || item.code || item.name"
                            v-model="item.selected"
                        >
                            【{{item.shop_name}}】{{item.name}}
                        </el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="备注">
                        <div style="font-size: 16px; font-weight: bold">{{data.remark}}</div>
                    </el-form-item>
                    <el-form-item label="已选项" class="query-form-item"></el-form-item>
                    <el-form-item label="" class="query-form-item">
                        <el-checkbox
                            v-for="item in getSelList"
                            :key="item.portfolio_id || item.code || item.name"
                            v-model="item.selected"
                        >
                            【{{item.shop_name}}】{{item.name}}
                        </el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row style="margin-top: 17px">
            <el-button
                style="float: right; margin-left: 6px"
                size="mini"
                type="danger"
                plain
                @click="handleClose(false)"
            >取 消
            </el-button
            >
            <el-button
                style="float: right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
            >确定
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/Product/Product'

    export default {
        data() {
            return {
                loading: false,
                searchTxt: '',
                adList: [],
            }
        },
        props: {
            data: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        mounted() {
            this.getList()
        },
        computed: {
            getSelList() {
                return this.adList.filter(item => item.selected)
            },
            getNoSelList() {
                const searchTxt = (this.searchTxt || '').toUpperCase()

                return this.adList.filter(item => {
                    const shopName = (item.shop_name || '').toUpperCase()
                    const name = (item.name || '').toUpperCase()
                    const state = (item.state || '').toUpperCase()

                    return !item.selected && (state.indexOf(searchTxt) !== -1
                        || shopName.indexOf(searchTxt) !== -1
                        || name.indexOf(searchTxt) !== -1
                        || (state + '-' + shopName + '-' + item.name).indexOf(searchTxt) !== -1
                    )
                })
            }
        },
        methods: {
            // 保存信息
            submitForm() {
                this.loading = true
                api.seed_word_asin_list_bind_asin_portfolio({
                    list_id: this.data.id || 0,
                    portfolio_ids: this.getSelList.map(item=>item.portfolio_id)
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('修改成功')
                        this.$emit('close')
                        this.$emit('onUpdate')
                    } else {
                        this.$message.error(res.message)
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            getList() {
                api.seed_word_asin_list_get_portfolio_list({list_id: this.data.id}).then(res => {
                    let arr = res.data || []
                    arr.map(item => {
                        item.selected = false
                        return item
                    })

                    const selData = (this.data.portfolio || []).map(item => {
                        return {
                            ...item,
                            selected: true,
                            name: item.portfolio_name
                        }
                    })

                    const selId = this.data.portfolio.map(item => item.portfolio_id)

                    arr = arr.filter(item => {
                        if (selId.includes(item.portfolio_id)) {
                            return false
                        }
                        return true
                    })

                    arr = arr.concat(selData)
                    console.log("arr-----", arr)
                    this.adList = arr
                })
            },
            // 关闭弹窗
            handleClose() {
                this.$emit('close')
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .selectBox {
        height: 600px;
        overflow-y: scroll;
    }
</style>
